module.exports = __webpack_public_path__ + "static/media/plant1.d2e73588.glb";